import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _awaitAsyncGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator.js";
import _wrapAsyncGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }
export var SmithyMessageDecoderStream = /*#__PURE__*/function (_Symbol$asyncIterator) {
  function SmithyMessageDecoderStream(options) {
    _classCallCheck(this, SmithyMessageDecoderStream);
    this.options = options;
  }
  _createClass(SmithyMessageDecoderStream, [{
    key: _Symbol$asyncIterator,
    value: function value() {
      return this.asyncIterator();
    }
  }, {
    key: "asyncIterator",
    value: function asyncIterator() {
      var _this = this;
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, message, deserialized;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context.prev = 2;
                _iterator = _asyncIterator(_this.options.messageStream);
              case 4:
                _context.next = 6;
                return _awaitAsyncGenerator(_iterator.next());
              case 6:
                if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                  _context.next = 18;
                  break;
                }
                message = _step.value;
                _context.next = 10;
                return _awaitAsyncGenerator(_this.options.deserializer(message));
              case 10:
                deserialized = _context.sent;
                if (!(deserialized === undefined)) {
                  _context.next = 13;
                  break;
                }
                return _context.abrupt("continue", 15);
              case 13:
                _context.next = 15;
                return deserialized;
              case 15:
                _iteratorAbruptCompletion = false;
                _context.next = 4;
                break;
              case 18:
                _context.next = 24;
                break;
              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context.t0;
              case 24:
                _context.prev = 24;
                _context.prev = 25;
                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context.next = 29;
                  break;
                }
                _context.next = 29;
                return _awaitAsyncGenerator(_iterator.return());
              case 29:
                _context.prev = 29;
                if (!_didIteratorError) {
                  _context.next = 32;
                  break;
                }
                throw _iteratorError;
              case 32:
                return _context.finish(29);
              case 33:
                return _context.finish(24);
              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 20, 24, 34], [25,, 29, 33]]);
      }))();
    }
  }]);
  return SmithyMessageDecoderStream;
}(Symbol.asyncIterator);